
import React from 'react';

import { isMobileBrowser } from '../../environment/utils';

import Tooltip from './Tooltip';

type Props = {

  /**
   * Children of the component.
   */
  children: React$Node,

  /**
   * Class name forwarded to the tooltip.
   */
  className?: string,

  /**
   * The text to be displayed in the tooltip.
   */
  content?: string | null,

  /**
   * The position of the tooltip relative to the element it contains.
   */
  position?: string,
};

/**
 * Wrapper of AtlasKit Tooltip that doesn't render the actual tooltip in mobile browsers.
 *
 * @returns {ReactElement}
 */
function TooltipWrapper({ children, className, content, position }: Props) {
    if (isMobileBrowser()) {
        return children;
    }

    return (
        <Tooltip
            className = { className }
            content = { content }
            position = { position }>
            {children}
        </Tooltip>
    );
}

export default TooltipWrapper;
